/*
 * product-page-badges.js — variant-aware badge visibility +
 * above-gallery portal.
 *
 * 1. Variant-aware visibility
 *    The block pre-renders every variant's badges in the DOM, each
 *    tagged with `data-variant-badge="{variant.id}"`. Non-current
 *    variants start with inline `display: none`. H3.0's
 *    `variant:update` event drives the swap; no fetch, instant.
 *
 * 2. Above-gallery portal
 *    Horizon doesn't expose block.settings via section.blocks
 *    iteration, so the Main Product gallery snippet can't filter
 *    badges blocks by their `show_above_gallery` toggle server-side.
 *    Instead, the block file always renders into its natural
 *    content-column position with a `data-portal-to="above-gallery"`
 *    attribute when the toggle is on. This script appendChild-moves
 *    every marked block into `.product-main-gallery__above` inside
 *    the same shopify-section at DOM-ready, wrapping it in the
 *    alignment-modifier div the gallery CSS expects. The
 *    `product-page-badges-block--portal-pending` class hides the
 *    block at its natural position until the move completes (no
 *    flash). Re-runs on shopify:section:load for the customizer.
 */
(function () {
  function setBadgeVisibility(scope, variantId) {
    if (!scope || !variantId) return;
    var id = String(variantId);
    var nodes = scope.querySelectorAll('[data-variant-badge]');
    for (var i = 0; i < nodes.length; i++) {
      var match = nodes[i].getAttribute('data-variant-badge') === id;
      nodes[i].style.display = match ? '' : 'none';
    }
  }

  function portalAboveGallery(scope) {
    var root = scope || document;
    var pending = root.querySelectorAll('[data-portal-to="above-gallery"]');
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      var section = el.closest('.shopify-section');
      if (!section) continue;
      var target = section.querySelector('.product-main-gallery__above');
      if (!target) continue;

      // Wrap in the alignment-modifier the gallery CSS keys off,
      // so the merchant's Left / Centre / Right selection applies
      // inside the above slot.
      var alignment = el.getAttribute('data-above-alignment') || 'left';
      var item = document.createElement('div');
      item.className =
        'product-main-gallery__above-item product-main-gallery__above-item--' + alignment;
      item.appendChild(el);
      target.appendChild(item);

      // Strip the marker + hide class so CSS unhides the block at
      // its new home.
      el.removeAttribute('data-portal-to');
      el.removeAttribute('data-above-alignment');
      el.classList.remove('product-page-badges-block--portal-pending');
    }
  }

  document.addEventListener('variant:update', function (event) {
    var detail = event && event.detail;
    var resource = detail && detail.resource;
    var variantId = resource && resource.id;
    if (!variantId) return;

    var sourceSection = event.target && event.target.closest
      ? event.target.closest('.shopify-section')
      : null;
    var scope = sourceSection || document;
    setBadgeVisibility(scope, variantId);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      portalAboveGallery();
    });
  } else {
    portalAboveGallery();
  }

  document.addEventListener('shopify:section:load', function (e) {
    portalAboveGallery(e.target);
  });
})();
